
var BackboneLangView = Backbone.Ribs.View.extend({
    bindings:{
        '.field-name':{
            value:'model.title.'
        },
        '.field-description':{
            value:'model.title.'
        }
    },
    initialize: function(opts) {
        this.lang = opts.lang;
        this.bindings = _.clone(this.bindings);
        this.bindings['.field-name'].value = 'model.title.'+this.lang;
        this.bindings['.field-description'].value = 'model.description.'+this.lang;
        this.fieldName = opts.fieldName;
        this.$el.html(Template7.compile(templates['MultiVideoRowLang.html'])({fieldName:this.fieldName,mLang:this.lang,position: this.model.get("order")}));
    }
});

var FunLoadIncrement = 0;

var BackboneLiView = Backbone.Ribs.View.extend({
    tagName:'li',
    bindings:{
        '.field-preview':{value:'model.preview'},
        '.field-url':{value:'model.url'},
        '.field-type':{value:"model.type"},
        '.field-mp4':{value:"model.mp4"},
        '.cropper':{
            css:{
                'background-image':{
                    data:'model.preview',
                    processor:function(preview){
                        if(preview && preview.length) {
                            return "url('"+preview+"')";
                        }
                        return "none";
                    }
                }
            }
        }
    },
    events:{
        "click .drop-it-button":"dropSelf",
        "change .field-url":"parseLink",
        "keyup .field-url":"parseLink"
    },
    initialize:function(options){
        this.$el.html(Template7.compile(templates['MultiVideoRow.html'])({fieldName:this.collection.fieldName,position:this.model.get("order")}));
        this.$el.hide();
        this.$el.attr("data-id",this.model.get("id"));

        //detect languages
        var langs = [];
        var defLang = "";
        $(".tab-nav [data-language]").each(function(){
            langs.push($(this).attr("data-language"));
            if($(this).hasClass("active")) {
                defLang = $(this).attr("data-language");
            }
        });
        this.langs = langs;
        this.currentLang = defLang.length? defLang: this.langs[0];

        this.langViews = {};
        for (var i in this.langs) {
            this.langViews[this.langs[i]] = new BackboneLangView({model:this.model, lang:this.langs[i], fieldName: this.collection.fieldName});
            this.$el.find(".lang-place").append(this.langViews[this.langs[i]].el);
            this.langViews[this.langs[i]].$el.hide();
        }

        this.FuncLoadName = "BSLoadVideo" + FunLoadIncrement;
        FunLoadIncrement++;

        window[this.FuncLoadName] = this.loadVimeoVideo.bind(this);

        if(!this.model.get("preview")) {
            this.$el.find(".cropper").css("opacity",0);
        }

        var self = this;
        $("body").on("click","[data-language]",function(e) {
            self.changeLang($(this).attr("data-language"));
        });

        this.changeLang(this.currentLang);
        this.currentLink = "";

        setTimeout(function(){
            this.$el.slideDown({start: function () {
                $(this).css({
                    display: "flex"
                })
            }});
        }.bind(this),0);
    },
    dropSelf: function(e){
        e.preventDefault();
        this.$el.slideUp(function(){
            this.collection.remove(this.model);
        }.bind(this));
        return false;
    },
    changeLang:function(setLang){
        for(var lang in this.langViews) {
            console.log(lang,setLang);
            if(lang == setLang) {
                this.langViews[lang].$el.show();
            }else{
                this.langViews[lang].$el.hide();
            }
        }
    },
    parseLink:function(e) {
        var link = this.$el.find(".field-url").val();
        if(this.currentLink==link) {
            return;
        }
        this.currentLink = link;

        var out = (/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/g).exec(link) || [];
        if(out[4]) {
            //
            //var script = document.createElement( 'script' );
            //script.src = "//vimeo.com/api/v2/video/" + out[4] + ".json?callback="+this.FuncLoadName;
            //$("body").append(script);
            $.getJSON('/events',{vimeo:out[4]},function(resp){
                this.loadVimeoVideo(resp);
            }.bind(this));
        }else{
            this.model.set({
                type:'',
                title:{},
                description:{}
            });
            this.$el.find(".cropper").animate({"opacity":0});
        }
    },
    loadVimeoVideo:function(video) {
        if(video && video.title.length) {
            //$preview.val(video[0].thumbnail_large);
            this.model.set({
                type:'vimeo',
                uel:video.url,
                preview:video.preview,
                mp4:video.mp4,
                title:{
                },
                description:{}
            });
            for(var lang in this.langViews) {
                this.model.set("title."+lang,video.title);
                this.model.set("description."+lang,video.description);
            }
            this.$el.find(".cropper").animate({"opacity":1});
            //$previewSrc.css("background-image","url('"+video[0].thumbnail_large+"')").animate({"opacity":1});
        }else{
            this.model.set({
                type:'',
                title:{},
                description:{}
            });
            this.$el.find(".cropper").animate({"opacity":0});
        }
    }
});


var BackboneMainView = Backbone.Ribs.View.extend({
    bindings:{
        '.images':{
            collection:{
                col:'videos',
                view:BackboneLiView
            }
        }
    },
    events:{
        "click button.add-row-button":"addRow",
        "click label":"dropDefault",
        "update .images":"rebuildOrdering"
    },
    initialize:function(opts) {
        this.$el.html('<div> <label style="padding: 0px 15px 1em;"> <ul class="images"></ul> <div class="row"><div class="col-sm-12"><button class="add-row-button btn btn-primary pull-right">'+window.LANGUAGE['events.form.videos.button']+'</button></div></div>  </label> </div>');
        var meta = [];
        var MID = 0;
        try {
            meta = JSON.parse(this.$el.attr("data-meta"));
            for(var i in meta) {
                meta[i].id = i;
                meta[i].order = i;
                MID = Math.max(MID,i);
            }
        } catch (e) {
            meta = [];
        }
        this.videos = new (Backbone.Ribs.Collection.extend({
            comparator:function(a,b){
                return a.get("order")-b.get("order");
            }
        }))(meta,{model:Backbone.Ribs.Model});
        this.videos.fieldName = opts.fieldName;
        this.videos.cc = MID + 1;
        if(!this.videos.cc < 0) {
            this.videos.cc = 0;
        }

        this.$el.find(".images").sortable({
            containerSelector: 'ul',
            itemSelector: 'li',
            handle:'.drag-wrap span',
            onDrop:this.rebuildOrdering.bind(this)
        });
    },
    addRow: function(e) {
        e.preventDefault();
        this.videos.add({
            id:this.videos.cc++,
            type:'',
            url:'',
            title:{},
            description:{},
            order:this.videos.cc
        });
        return false;
    },
    dropDefault:function(e){
        e.preventDefault();
        return false;
    },
    rebuildOrdering:function($item, container, _super, event) {
        $item.removeClass(container.group.options.draggedClass).removeAttr("style");
        $("body").removeClass(container.group.options.bodyClass);
        //var cset = [];
        this.$el.find(".images li[data-id]").each(function(i,el) {
            //cset.push(this.videos.find(parseInt($(el).attr('data-id'))));
            this.videos.get(parseInt($(el).attr('data-id'))).set("order",i);
        }.bind(this));
        //this.videos.reset(cset);
        this.videos.sort();
    }
});



var FactoryMultiVideos=0;
function MultiVideos(element,fieldName)
{
    FactoryMultiVideos++;
    new BackboneMainView({
        el:element,
        fieldName:fieldName
    });
    //this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}
/*
var KeyLogErs = 0;

$.extend(MultiVideos.prototype,{
    el:null,
    $el:null,
    template:'<div> <label style="padding: 0px 15px 1em;"> <ul class="images"></ul> <div class="row"><div class="col-sm-12"><button class="btn btn-primary pull-right">'+window.LANGUAGE['events.form.videos.button']+'</button></div></div>  </label> </div>',
    content:null,
    input:null,
    images:null,
    fieldName:'pdfs',
    meta:{},
    langs:[],
    currentLang:'',
    init:function(element,fieldName) {
        this.el=element;
        this.$el=$(this.el);
        this.fieldName=fieldName;

        //detect languages
        var langs = [];
        var defLang = "";
        $(".tab-nav [data-language]").each(function(){
            langs.push($(this).attr("data-language"));
            if($(this).hasClass("active")) {
                defLang = $(this).attr("data-language");
            }
        });
        this.langs = langs;
        this.currentLang = defLang.length? defLang: this.langs[0];

        this.changeLocale(this.currentLang);
        var self =this;
        $("body").on("click","[data-language]",function() {
            self.changeLocale($(this).attr("data-language"));
        });

        this.content=$(this.template);
        this.content.find("button").on("click", this.addNewField.bind(this));
        this.images=this.content.find("ul.images");
        this.$el.append(this.content);
        this.$el.find(".images").sortable({
            containerSelector: 'ul',
            itemSelector: 'li',
            handle:'.drag-wrap span'
        });

        this.grabImages();
    },
    changeLocale:function(slang,$el) {
        if(_.isUndefined($el)) {
            $el = this.$el;
        }
        this.currentLang = slang;
        for(var i in this.langs) {
            var lang = this.langs[i];
            $el.find(".show-lang-"+lang).hide();
        }
        $el.find(".show-lang-"+slang).show();
    },
    addNewField:function(e) {
        e.preventDefault();
        this.createCropper();
        return false;
    },
    grabImages:function()
    {
        var imgs=this.$el.find("span.slide-self");

        for(var i=0;i<imgs.length;i++)
        {
            var img = $(imgs[i]);
            var meta=JSON.parse("{}");
            if(!_.isUndefined(img.attr("data-meta")))
                _.extend(meta,JSON.parse(img.attr("data-meta")));
            console.log('AAAA',meta);
            this.createCropper(null,_.clone(meta));
            img.remove();

        }
    },
    createCropper: function(file, meta) {
        // create container element for cropper
        var self = this;
        var htmlCropper = '<li><div class="row flex-row"><div class="col-sm-1 drag-wrap"><span></span></div><div class="col-sm-3 cropper"></div><div class="col-sm-7">';
        var used = [];
        htmlCropper += '<input name="'+this.fieldName+'['+KeyLogErs+'][type]" type="hidden" class="field-type" value=""/>' +
        '<input name="'+this.fieldName+'['+KeyLogErs+'][preview]" type="hidden" class="field-preview" value=""/>';
        for(var ie  in this.langs) {
            var lang = this.langs[ie];
            if(used.indexOf(lang)!==-1) {
                continue;
            }
            used.push(lang);
            htmlCropper +=
             //   '<div class="show-lang-'+lang+' text-show-place">' +
                '<div class="fg-line">' +
                '<input class="form-control field-url" data-key="action" name="'+this.fieldName+'['+KeyLogErs+'][url]" data-lang="'+lang+'" value="" placeholder="'+LANGUAGE["events.form.video.url"]+'"/></div><div class="fg-line m-t-10">' +
                '<input class="form-control field-name" data-key="action" name="'+this.fieldName+'['+KeyLogErs+'][title]['+lang+']" data-lang="'+lang+'" value="" placeholder="'+LANGUAGE["events.form.video.title"]+'"/></div> <div class="fg-line m-t-15">' +
                '<textarea data-no-summernote="true" rows="3" name="'+this.fieldName+'['+KeyLogErs+'][description]['+lang+']" class="form-control field-description" data-key="description" data-lang="'+lang+'" placeholder="'+LANGUAGE['intro.description']+'">'+((meta && meta.description && meta.description[lang]) ?  meta.description[lang] : '')+'</textarea>' +
            //    '</div>' +
                '</div>';
            break;
        }
        htmlCropper += '</div></div><button class="drop-it-button btn btn-danger"><i class="fa fa-trash"></i></button></li>';

        var cropper = $(htmlCropper);
        cropper.on("click",function(e){ e.preventDefault(); return false;});
        cropper.on("click mousedown mouseup mousemove",".cropper",function(e){ e.preventDefault(); return false;});
        $url = cropper.find(".field-url");
        $type = cropper.find(".field-type");
        $name = cropper.find(".field-name");
        $description = cropper.find(".field-description");
        $preview = cropper.find(".field-preview");
        $previewSrc = cropper.find(".cropper");
        $previewSrc.css("opacity",0);

        var FuncLoadName = 'LoadVimeoVideo'+KeyLogErs;
        var currentLink = "";

        window[FuncLoadName] = function(video) {
            if(video && video.length) {
                $type.val("vimeo");
                $name.val(video[0].title);
                $preview.val(video[0].thumbnail_large);
                $description.val(video[0].description);
                $url.val(video[0].url);
                $previewSrc.css("background-image","url('"+video[0].thumbnail_large+"')").animate({"opacity":1});
            }else{
                $type.val("");
                $name.val("");
                $preview.val("");
                $description.val("");
                $previewSrc.animate({"opacity":0});
            }
        };

        $url.on("change keyup", function(){
            var link = $url.val();
            if(currentLink==link) {
                return;
            }
            currentLink = link;
            var out = (/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/g).exec(link) || [];
            if(out[4]) {
                //
                var script = document.createElement( 'script' );
                script.src = "//vimeo.com/api/v2/video/" + out[4] + ".json?callback="+FuncLoadName;
                $("body").append(script);
                $type.val("");
                $name.val("");
                $preview.val("");
                $description.val("");
                $previewSrc.animate({"opacity":0});
            }else{
                $type.val("");
                $name.val("");
                $preview.val("");
                $description.val("");
                $previewSrc.animate({"opacity":0});
            }
        }.bind(this));

        this.changeLocale(this.currentLang,cropper);

        this.images.append(cropper);

        cropper.find("button").on("click", function(e){
            e.preventDefault();
            cropper.remove();
            return false;
        }.bind(this));
        KeyLogErs++;
    }
});

$(function(){
    $(".MultiVideos").each(function(i,item){
        if(item.multi)
            return;
        item.multi = new MultiVideos(item, $(item).attr("data-field"));
    });
});

function OnSlimUploadSetDirty(f,i) {
    $('form').attr('data-dirty','true');
    return true;
}*/